import { Container, Grid, Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ProyectoOds } from "../../Interface/IProyectoOds";
import { I18nContext } from "../../I18nProvider";
import { useContext } from "react";

export interface ProyectoProps {
    proyectos: ProyectoOds[];
}

export const Proyectos: React.FC<ProyectoProps> = ({ proyectos }) => {
    const navigate = useNavigate();
    const context = useContext(I18nContext);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }
    
    const parseDate = (dateString: string): Date => {
        const [day, month, year] = dateString.split("/").map(Number);
        return new Date(year, month - 1, day); 
    };

    
    const columns: GridColDef[] = [
        {
            field: "fechainicio",
            headerName: context.t.translate("proyecto.fechain"),  resizable: false,
            flex: 0.2,
            sortComparator: (v1, v2) => parseDate(v1).getTime() - parseDate(v2).getTime(), 
        },
        { field: "titulo", headerName: context.t.translate("proyecto.titulo"), flex: 0.6, resizable: false},
        { field: "estado", headerName: context.t.translate("proyecto.estado"), flex: 0.2, resizable: false },
    ];

    
    const rows = proyectos.map((proyecto) => ({
        id: proyecto.idproyecto,
        fechainicio: proyecto.fechainicio,
        titulo: proyecto.titulo,
        estado: proyecto.estado,
    }));

    
    const handleRowClick = (params: any) => {
        const { id } = params.row;
        navigate(`/proyecto/${id}`);
    };

    return (
        <Container>
            
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} md={8}>
                    <Paper elevation={3} style={{ width: "100%", height: 400 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSizeOptions={[25]}
                            onRowClick={handleRowClick}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 25,
                                    },
                                },
                            }}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            sx={{
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "blue !important",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                },
                                "& .MuiDataGrid-cell": {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                                "& .MuiDataGrid-row:hover": {
                                    cursor: "pointer",
                                    backgroundColor: "#f5f5f5",
                                },
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};
